export const NAVIGATION_BUTTONS_STYLE_SIDES = 'sides';
export const NAVIGATION_BUTTONS_STYLE_TOP = 'top';

export const NAVIGATION_BUTTONS_STYLES = [
  { name: 'onTheSides', value: 'sides' },
  { name: 'onTop', value: 'top' }
];
